export const BaseFieldMixin = {
  props: {
    value: null,
    fieldKey: {
      type: String,
      required: true,
      default: () => {
        return ''
      }
    },
    fieldType: {
      type: String,
      required: true,
      default: () => {
        return 'plain-text'
      }
    },
    fieldSelectItems: {
      type: Array,
      required: true,
      default: () => {
        return []
      }
    }
  }
}
